@import '../../../theme.scss';

verdocs-pagination {
  gap: 8px;
  display: flex;
  flex-direction: row;
  font-family: $primary-font;

  .page-button {
    height: 38px;
    display: flex;
    flex: 0 0 38px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    color: $verdocs-dark-blue;
    border: 1px solid $verdocs-purple;

    svg {
      width: 18px;
      height: 18px;
    }

    &.selected {
      cursor: default;
      color: $verdocs-grey-4;
      background: $verdocs-purple;
    }
  }

  .ellipsis {
    width: 38px;
    height: 38px;
    display: flex;
    flex: 0 0 38px;
    line-height: 32px;
    justify-content: center;
    color: $verdocs-dark-blue;
  }
}
